// extracted by mini-css-extract-plugin
export default {"root":"QueueSort-root-ddab32569348ca1580840dd7f9eb443e"};